__turbopack_context__.v({
  "button": "styles-module-scss-module__aNOwBa__button",
  "description": "styles-module-scss-module__aNOwBa__description",
  "gameRoot": "styles-module-scss-module__aNOwBa__gameRoot",
  "games": "styles-module-scss-module__aNOwBa__games",
  "icon": "styles-module-scss-module__aNOwBa__icon",
  "noGamesAvailable": "styles-module-scss-module__aNOwBa__noGamesAvailable",
  "root": "styles-module-scss-module__aNOwBa__root",
  "shimmer": "styles-module-scss-module__aNOwBa__shimmer",
  "skeletonBox": "styles-module-scss-module__aNOwBa__skeletonBox",
  "title": "styles-module-scss-module__aNOwBa__title",
});
